import React, { Component } from 'react'
import { Route, Redirect } from 'react-router-dom'
import { isDevelopment, ZeroLead } from '../module/helpers'

class RoutePublic extends Component {
  redirectComponent = (props, to) => {
    return <Redirect to={props.redirect !== undefined ? props.redirect : to} />
  }

  render() {
    const {
      component: Component,
      isAuthenticated,
      is2FARequired,
      is2FAVerified,
      to,
      ...rest
    } = this.props

    return (
      <React.Fragment>
        <Route
          {...rest}
          render={(props) => {
            if (isDevelopment)
              console.log("🔍 RoutePublic props:", {
                isAuthenticated,
                is2FARequired,
                is2FAVerified,
                pathname: props.location.pathname
              })

            // 🚨 Jika user sedang proses 2FA → jangan biarkan masuk login
            if (is2FARequired && !is2FAVerified) {
              if (props.location.pathname !== "/2fa") {
                if (isDevelopment)
                  console.log("➡ Redirect → /2fa (RoutePublic)")
                return <Redirect to="/2fa" />
              }
            }

            // Jika sudah login normal → redirect ke halaman tujuan
            if (isAuthenticated) {
              if (isDevelopment)
                console.log("➡ Redirect (public) ke:", to)
              return this.redirectComponent(props, to)
            }

            // Jika belum login → tampilkan halaman public
            return <Component {...props} />
          }}
        />
      </React.Fragment>
    )
  }
}

// RoutePublic.propTypes = {
const tahun = new Date().getFullYear()
const bulan = new Date().getMonth()
const _bulan = ZeroLead(bulan + 1, 2)

RoutePublic.defaultProps = {
  // to: `/dashboard?tahun=${tahun}&bulan=${_bulan}`,
  to: `/redirect`,
}

export default RoutePublic
